import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { Button, Drawer, Table, Row, Input, Divider, message } from 'antd';
import ReportConfigAddEdit from './report_config_addedit';
import Title from 'antd/lib/typography/Title';
import ReportParticipants from './report_participants';
import ReportActions from './report_actions';
import { NetworkDelaySearch, showErrorInNotification, formatMoney } from '../../lib/util';
import { BasicHeader } from '../../components/basic_header';
import { reports_quick_menu } from '../../util/ui_util';

import {PauseCircleFilled,PlayCircleFilled} from '@material-ui/icons';


const queryString = require('query-string');


class MyReportList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            add_edit_status: null,
            edit_report_id: null,
            edit_report_data: {},
            filter_query: {},
            participant_drawer:false,
            report_actions_drawer:false,
            selected_report_config_id:null
        }

        this.list_reports = RESTExecutor.list().config({
            label: 'report_configs',
            params:{
                per_page:100,
                page:1
            }
        }).connect(props.domains.reports)

        this.patch_report=RESTExecutor.patch().config({
            label:'report_configs_detail'
        })
        .callbacks((success)=>{
            message.success(success.result.message||"Operation Completed");
            this.list_reports.execute();
        },(error)=>{
            showErrorInNotification(error)
        })
        .connect(props.domains.reports);


        this.delay_search=new NetworkDelaySearch();

    }
    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        
        const { add_edit_status, edit_report_data, edit_report_id, filter_query } = this.state;


        let list_reports_resp = this.list_reports.response();
        let patch_report_resp=this.patch_report.response();
        let rowsData = (list_reports_resp.result && list_reports_resp.result.rows) || [];
        let rowsMeta = list_reports_resp.meta || {};

        return (
            <div>
                <BasicHeader
                    no_back
                    title="Report Settings"
                    menu_items={reports_quick_menu}

                    
                />

<div className='filter-card'>
                    <div  className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                         <Input.Search
                            placeholder="Search For"
                            style={{
                                // width: 300
                            }}
                            autoFocus
                            value={filter_query.query}
                            onChange={(e) => {

                                this.stateUpdater({
                                    stateKey: 'filter_query',
                                    valueKey: 'query',
                                    appendObj:{
                                        per_page:100,page:1
                                    },
                                    value: e.target.value,
                                    callback:()=>{
                                        this.delay_search.onSearch(()=>{
                                            this.props.history.push({
                                                // pathname:"users",
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                        })
                                       
                                    }
                                })
                            }}
                            onSearch={(value) => {
                                // this.list_reports.config({
                                //     params: {
                                //         ...filter_query
                                //     }
                                // }).execute()
                            }}
                        />
                        </div></div>
            <div className='default-card' style={{ padding: 8 }}>
                {/* <Row type='flex' justify='end'>
                   
                </Row> */}
                <Table
                    className='main-table'
                    loading={list_reports_resp.fetching||patch_report_resp.fetching}
                    size='small'
                    scroll={{x:true}}
                    pagination={{
                        simple: false,
                        position:'bottom',
                        onChange: (current, size) => {
                            this.props.history.push({
                                search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                            })
                        },
                        defaultCurrent: 1,
                        current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                        // defaultPageSize: 20,
                        pageSize: (rowsMeta && rowsMeta.requested_count),

                        total: (rowsMeta && rowsMeta.total_count),
                        showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                    }}
                    // bordered={false}
                    title={() => <div><Row type='flex' justify='space-between' style={{
                        alignItems: 'center',
                        flexWrap: 'nowrap'
                    }}>
                        {/* <Title style={{
                        margin: 0
                    }}>Report Configs</Title> */}
                    <div></div>
                     <Button type='primary' onClick={() => {
                        this.setState({ add_edit_status: 'add' })
                    }}>Add New</Button>

                        

                    </Row>
                    </div>}
                    rowKey={(record) => record.id}
                    columns={[
                        { title: "Name", dataIndex: 'name', key: 'name' },
                        { title: "Description", dataIndex: 'description', key: 'description' },
                        {
                            title: "", dataIndex: "id", key: 'id', render: (id, data) => {
                                return <div style={{
                                    display:'flex',
                                    flexDirection:'row',
                                    alignItems:'center'
                                }}><Button type='link' style={{padding:0}} onClick={() => {
                                    this.setState({
                                        add_edit_status: 'edit',
                                        edit_report_id: id,
                                        edit_report_data: JSON.parse(JSON.stringify(data)),
                                    })
                                }}>Edit</Button>
                                <Divider type='vertical'/>
                                <Button type='link' style={{padding:0}} onClick={() => {
                                    this.setState({
                                        report_actions_drawer: true,
                                        selected_report_config_id: id,
                                    })
                                }}>Actions</Button>
                                <Divider type='vertical'/>
                                <Button type='link' style={{padding:0}} onClick={() => {
                                    this.setState({
                                        participant_drawer:true,
                                        edit_report_id: id,
                                    })
                                }}>Participants</Button>
                                  <Divider type='vertical'/>
                                    <Button type='link' onClick={() => {
                                        this.patch_report.forId(id).execute({
                                    stop:data.stop?false:true
                                });
                            }}>{data.stop?<PlayCircleFilled className='success-icon' titleAccess='Tap to resume'/> : <PauseCircleFilled className='danger-icon' titleAccess='Tap to pause'/>}</Button>

                                </div>
                            }
                        }
                    ]}
                    dataSource={rowsData}
                />

                <Drawer
                title="Report Config Actions"
                placement="right"
                closable={false}
                width='50%'
                destroyOnClose
                onClose={() => {
                    this.setState({
                        report_actions_drawer: false,
                        selected_report_config_id: null,
                    })
                }}
                visible={this.state.report_actions_drawer}
                >
                    <ReportActions
                    config_id={this.state.selected_report_config_id}
                    key={`${this.state.selected_report_config_id}--`}
                    />
                </Drawer>
                <Drawer
                    title="Report Config Add"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                        this.setState({
                            add_edit_status: null,
                            edit_report_id: null,
                            edit_report_data: {},
                        });
                        this.list_reports.execute();
                    }}
                    visible={this.state.add_edit_status === 'add'}
                >
                    <ReportConfigAddEdit
                        onClose={() => {
                            this.setState({
                                add_edit_status: null,
                                edit_report_id: null,
                                edit_report_data: {},
                            });
                            this.list_reports.execute();
                        }}
                        // onCloseReload={()=>{
                        //     this.list_reports.execute();
                        //     this.setState({
                        //         add_edit_status: null,
                        //         edit_report_id: null,
                        //         edit_report_data: {},
                        //     })
                        // }}
                    />
                </Drawer>

                <Drawer
                    title="Report Config Edit"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                        this.setState({
                            add_edit_status: null,
                            edit_report_id: null,
                            edit_report_data: {},
                        });
                        this.list_reports.execute();
                    }}
                    visible={this.state.add_edit_status === 'edit'}
                >
                    <ReportConfigAddEdit
                        onClose={() => {
                            this.setState({
                                add_edit_status: null,
                                edit_report_id: null,
                                edit_report_data: {},
                            });
                            this.list_reports.execute();
                        }}
                        // onCloseReload={()=>{
                        //     this.list_reports.execute();
                        //     this.setState({
                        //         add_edit_status: null,
                        //         edit_report_id: null,
                        //         edit_report_data: {},
                        //     })
                        // }}
                        edit_id={edit_report_id}
                        edit_data={edit_report_data}
                    />
                </Drawer>

                <Drawer
                    title="Report Participants"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                        this.setState({
                            participant_drawer: false,
                            edit_report_id:null
                        })
                    }}
                    visible={this.state.participant_drawer}
                >
                    <ReportParticipants 
                    report_id={edit_report_id}
                    />
                </Drawer>
            </div>
            </div>
        );
    }
    componentDidMount() {
        this.list_reports.execute();
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_reports.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })
    }

    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_reports.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }
}

export default withDomains(MyReportList, "reports");
